import { ref, computed } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { DraftingApi as DraftingApiSymbol } from '../domains/apis';
import type { DraftingApi, OldDraftingInitDataResponse } from '../domains/apis';
import { AgentType } from '../constants/enum';

export const useOldInitData = createGlobalState(() => {
    const draftingApi = injectService<DraftingApi>(DraftingApiSymbol);
    const initData = ref<OldDraftingInitDataResponse | null>(null);
    const loading = ref(false);
    const error = ref<string | null>(null);

    const permission = computed(() => {
        const config = {
            [AgentType.DISCLOSURE]: false,
            [AgentType.PATENT_DRAFT]: false,
        };

        if (!initData.value?.permission || loading.value) {
            return config;
        } else {
            const {
                ai_disclosure,
                ai_specification_cn,
                ai_specification_eu,
                ai_specification_us,
                ai_specification_unified,
            } = initData.value.permission || {};

            config[AgentType.DISCLOSURE] = !!ai_disclosure;

            config[AgentType.PATENT_DRAFT] = !!ai_specification_cn ||
                !!ai_specification_eu ||
                !!ai_specification_us ||
                !!ai_specification_unified;
        }

        return config;
    });

    const fetchOldDraftingInitData = async() => {
        loading.value = true;
        error.value = null;

        try {
            const result = await draftingApi.getOldDraftingInitData();
            initData.value = result;
        } catch (err) {
            console.error('[useOldInitData] 请求失败:', err);
        } finally {
            loading.value = false;
        }
    };

    fetchOldDraftingInitData();

    return {
        initData,
        loading,
        error,
        fetchOldDraftingInitData,
        permission,
    };
})
